import React from 'react'

export default function TermsAndConditions() {
    return (
        <>
            <section className="py-5">
                <div className="container px-5 my-5">
                    <div className="row gx-5 justify-content-center">
                        <div className="col-lg-8 col-xl-10">
                            <div className="text-center">
                                <h2 className="fw-bolder">Terms &amp; Conditions</h2>
                                <p className="lead fw-normal text-muted mb-5">
                                    Welcome to Uyirmozhy, a platform dedicated to books, authors, and publishing.
                                    By using our website (.in), you agree to the following terms and conditions.
                                    Please read them carefully before browsing or using our content.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-5 align-items-center">
                        <div className="col-lg-12">
                            <h4 className="fw-bolder">1. Acceptance of Terms</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                By accessing or using this website, you agree to be bound by these Terms and Conditions and our Privacy Policy.
                                If you do not agree with any part of these terms, please do not use the website.
                            </p>
                            <h4 className="fw-bolder">2. Use of Website Content</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                All text, images, logos, and other content on this website are the property of Uyirmozhy or used with permission from their respective owners.
                                You may:
                                <ul>
                                    <li>View, read, and share our content for personal and non-commercial purposes.</li>
                                </ul>
                                You may not:
                                <ul>
                                    <li>Copy, reproduce, republish, or distribute any content without written permission</li>
                                    <li>Modify or reuse any material for commercial or promotional use.</li>
                                </ul>
                            </p>
                            <h4 className="fw-bolder">3. Accuracy of Information</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                We strive to ensure that all information on our site is accurate and up-to-date.
                                However, Uyirmozhy does not guarantee that all information, book details, or author bios are free from errors or omissions.
                                We may update or correct content at any time without prior notice.
                            </p>
                            <h4 className="fw-bolder">4. External Links</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                Our website may include links to third-party websites or resources for reference.
                                We are not responsible for the content, accuracy, or policies of those external sites. Visiting them is at your own discretion.
                            </p>
                            <h4 className="fw-bolder">5. User Submissions</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                If you share any content with us (such as messages, feedback, or manuscripts), you grant Uyirmozhy the right to review and respond to them.
                                We will not publish or use your material publicly without your consent.
                            </p>
                            <h4 className="fw-bolder">6. Limitation of Liability</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                Uyirmozhy and its team are not responsible for any direct, indirect, or incidental damages arising from your use of this website.
                                Your use of the site is entirely at your own risk.
                            </p>
                            <h4 className="fw-bolder">7. Copyright and Ownership</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                All content on this website, including text, design, graphics, and images, is protected under applicable copyright laws.
                                Any unauthorized use may result in legal action.
                            </p>
                            <h4 className="fw-bolder">8. Changes to Terms</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                Uyirmozhy reserves the right to modify or update these Terms and Conditions at any time.
                                All updates will be posted on this page with the revised effective date.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
